import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PunchListViewOptions, Status } from "../../Constants/Consts";
import List from "../../components/CoreComponents/List";
import { RootState } from "../../store/store";
import { PunchlistApiType } from "../../types/PunchList/PunchListSchema";
import SectionHeader from "../../components/CoreComponents/Details/SectionHeader";
import { TbChecklist } from "react-icons/tb";
import { MdOutlinePostAdd } from "react-icons/md";

export default function PunchList() {
    const { SelectedUser } = useSelector((state: RootState) => state.SelectedUser);
    const { allDisciplines: disciplines } = useSelector((state: RootState) => state.Discipline);
    const { ProjectPunchLists } = useSelector((state: RootState) => state.PunchList);
    const navigate = useNavigate();

    interface GroupedPunchList {
        name: string;
        onClickFunction: () => void;
        punchLists: PunchlistApiType[];
    }

    const groupedPunchLists: GroupedPunchList[] = [];
    disciplines.forEach((discipline) => {
        groupedPunchLists.push({
            name: discipline.disciplineName,
            onClickFunction: () => navigate(`/PunchListDiscipline/${discipline.disciplineId}`, { state: { disciplinId: discipline.disciplineId } }),
            punchLists: ProjectPunchLists.filter(pl => Number(pl.assignedDisciplineId) === Number(discipline.disciplineId)),
        });
    });

    groupedPunchLists.push({
        name: PunchListViewOptions.ERM_RELEVANT.label,
        onClickFunction: () => navigate(`/PunchList/${PunchListViewOptions.ERM_RELEVANT.name}/view`),
        punchLists: ProjectPunchLists.filter(pl => pl.ermRelevant),
    });

    groupedPunchLists.push({
        name: PunchListViewOptions.MY_PUNCH_LISTS.label,
        onClickFunction: () => navigate(`/PunchList/${PunchListViewOptions.MY_PUNCH_LISTS.name}/view`),
        punchLists: ProjectPunchLists.filter(pl => pl.identifiedBy === SelectedUser.kionEmail),
    });

    groupedPunchLists.push({
        name: PunchListViewOptions.ALL_PUNCH_LISTS.label,
        onClickFunction: () => navigate(`/PunchList/${PunchListViewOptions.ALL_PUNCH_LISTS.name}/view`),
        punchLists: ProjectPunchLists,
    });

    // Disabling for now until we decide on external user permissions 
    // const isExternal = SelectedUser.role === 'External';
    const isExternal = false;

    return (
        <div className="max-w-4xl">
            <div className="flex justify-between items-center mt-4 mb-4 max-w-4xl mx-auto">
                <SectionHeader title="Punch List Details" />
                {!isExternal && (
                    <div className="flex items-center hover:bg-orange-1000 hover:text-white rounded-lg p-2 group hover:cursor-pointer" onClick={() => navigate(`/PunchList/Form/Discipline/1`)}>
                        <MdOutlinePostAdd className="w-10 h-10 text-orange-1000 group-hover:text-white" />
                        <div className="ml-2 cursor-pointer text-base" data-testid="add-new-punchlist-issue-button">
                            Add New Punch List Issue
                        </div>
                    </div>
                )}
            </div>
            <List
                name="punchlist"
                data={groupedPunchLists}
                rowHoverClassName="hover:bg-orange-1000 hover:text-white hover:cursor-pointer"
                renderChildItem={(item) => () => (
                    <div className="flex items-center">
                        <TbChecklist className="w-16 h-16 text-orange-1000 group-hover:text-white" />
                        <div className="ml-2">
                            <h2 className="uppercase font-semibold">{item.name}</h2>
                            <div>
                                <span className="text-sm text-gray-600 dark:text-gray-300 group-hover:text-white">
                                    {item.punchLists.filter(l => l.statusId === Status.Pending).length} Pending Punch List
                                </span>
                            </div>
                            <div>
                                <span className="text-sm text-gray-600 dark:text-gray-300 group-hover:text-white">
                                    {item.punchLists.filter(l => l.statusId === Status.MaterialsReceived).length} Materials Received Punch List
                                </span>
                            </div>
                        </div>
                    </div>
                )}
                onClick={(item) =>item.onClickFunction()}
                isItemDisabled={false}
            />
        </div>
    );
}
